(function(angular) {
    angular.module('bizPartEngage').directive('bizModuleBlogList', bizModuleBlogListDirective);

    bizModuleBlogListDirective.$inject = [];

    function bizModuleBlogListDirective() {
        var directive = {
            restrict: "E",
            scope: {
                settings: "="
            },
            templateUrl: function(element, attr) {
                if (attr.templateurl) {
                    return siteRootPath + attr.templateurl;
                } else {
                    return siteRootPath + "FrontEnd/Modules/Blog/Views/blog-list.html"
                }
            },
            controller: bizModuleBlogListController,
            controllerAs: "vm",
            bindToController: true
        };

        bizModuleBlogListController.$inject = ["$rootScope", "modules.blog.service", "$timeout", "$sce", "core.services.favorite"];

        function bizModuleBlogListController($rootScope, blogService, $timeout, $sce, favoritesService) {
            var vm = this;
            vm.BlogItems = [];

            vm.Init = Init;

            function Init() {
                var ids = [];

                if(!vm.settings) {
                    console.warn('No settings provided...');
                    return;
                }
                
                if(!vm.settings.Filter && vm.settings.SelectedFilter) vm.settings.Filter = vm.settings.SelectedFilter.Value;
                if(!vm.settings.Limit && vm.settings.SelectedLimit) vm.settings.Limit = vm.settings.SelectedLimit.Value;

                if(vm.settings.Filter == 'newest') {
                    blogService.GetNewestBlogEntries(0, true, true, null, vm.settings.Limit + 1).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'journey') {
                    blogService.GetBlogEntriesByJourneyOrder(0, true, true, $rootScope.FavoriteTagIds, vm.settings.Limit + 1).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'related') {
                    blogService.GetRelatedBlogPosts(vm.settings.RelatedId).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'mostcommented') {
                    blogService.GetMostCommentedPosts(vm.settings.Limit).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'mostliked') {
                    blogService.GetMostLikedPosts(vm.settings.Limit).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'featured') {

                    for(var i = 0; i < vm.settings.Limit; i++) {
                        ids.push(vm.settings.SelectedBlogs[i].Id);
                    }
                    
                    blogService.GetBlogPosts(ids).then(GetBlogPostsSuccess);
                }

                function GetBlogPostsSuccess(response) {
                    if(vm.settings.Filter == 'featured') {
                        vm.BlogItems = [];

                        for(var i = 0; i < ids.length; i++) {
                            vm.BlogItems.push(response.data.GetItemByValue('Id', ids[i]));
                        }
                    }
                    else {
                        vm.BlogItems = response.data;
                    }
                }
            }

            vm.$onInit = vm.Init;

            if (angular.version.major === 1 && angular.version.minor < 5) {
                vm.$onInit();
            }
        }

        return directive;
    }
})(window.angular);
